import { useState, useEffect, useRef } from 'react'
import { Link, useNavigate, useLocation } from "react-router-dom"
import styles from './RegistrantToGuestMapping.module.css'

// ------ Services ------ //
import * as badgeManagementService from '../../../services/badgeManagementService'
import * as clientEventService from '../../../services/clientEventService'
import LoadingSpinner from "../../../components/Miscellaneous/LoadingSpinner"
import BackSaveContinueButton from '../../../components/Miscellaneous/BackSaveContinueButton'

// components - form
const RegistrantToGuestMapping = () => {

    // State
    const [clientEventInfo, setClientEventInfo] = useState({})
    
    // useLocation & useNavigate --- Client state from previous page
    const navigate = useNavigate()
    const location = useLocation()
    const passedState = location.state
    const [formData, setFormData] = useState({
        clientId: clientEventInfo.clientId,
        eventId: clientEventInfo.eventId,
        mainViewField: null,
        guestViewField: null,
    })
    const [loaded, setLoaded] = useState(false)
    const [mainViewFields, setMainViewFields] = useState([])
    const [guestViewFields, setGuestViewFields] = useState([])
    const clientEventInfoRef = useRef(null);
    const [continueButtonVisibility, setContinueButtonVisibility] = useState(false)
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }

    }
  
    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])

    // --- REST --- //
    const createRequestBody = async () => {

        let requestBody = {}

        if (clientEventInfo.clientId && clientEventInfo.eventId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`
            }
        }

        return await requestBody;
    }

   
    // Ensures state resets if user selects different qrchoice after partially filling out another
    const clearAllForms = () => {
    }

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        })
        handleContinueButtonVisiblity();
    }

    useEffect(() => {
        if (formData) {
            handleContinueButtonVisiblity();
        }
    }, [formData])
    const isFormValid = () => {
        return (formData.mainViewField 
            && formData.guestViewField 
            ? true
            : false)
    }
    
    const handleSaveAndNavigate = async e => {
        e.preventDefault()

        // call back end service here to POST form data
        try {
            await handleSave(e);
        } catch (err) {
            console.log(err)
        }
        clearAllForms();
        navigate(`/BadgeToERSPropertyGuestMapping`, { state: clientEventInfo })
    }
    const handleSave = async e => {
        e.preventDefault()

        let appended = {
            "clientId": `${formData.clientId}`,
            "eventId": `${formData.eventId}`,
            "mainViewField": `${formData.mainViewField}`,
            "guestViewField": `${formData.guestViewField}`,
        };
        // console.log(appended)

        // call back end service here to POST form data
        try {
            badgeManagementService.saveGuestSetup(appended)
        } catch (err) {
            console.log(err)
        }
    }
    const handleContinueButtonVisiblity = () => {
        //console.log(dataValidationObj.includes(false))
        if (formData.mainViewField
            && formData.guestViewField) {
            setContinueButtonVisibility(true)
        }
        else {
            setContinueButtonVisibility(false)
        }
    }

    useEffect(() => {
        if (!clientEventInfo?.clientId || !clientEventInfo?.clientName) return;
            
        const fetchSetupData = async () => {
            const getReqBody = await createRequestBody()
            const viewFields = await badgeManagementService.getViewFields(getReqBody)
            if (viewFields) {
                setMainViewFields(viewFields);
            }
            const guestViewFields = await badgeManagementService.getGuestViewFields(getReqBody)
            if (guestViewFields) {
                setGuestViewFields(guestViewFields);
            }
            const guestSetup = await badgeManagementService.getGuestSetup(getReqBody)
            if (guestSetup) {
                setFormData(guestSetup)
            }
            setLoaded(true);
        }
        fetchSetupData()
        
    }, [clientEventInfo])
    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
                formData.clientId = clientEventInfoRef.current.clientId
                formData.eventId = clientEventInfoRef.current.eventId
                setFormData(formData)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
            formData.clientId = passedData.clientId
            formData.eventId = passedData.eventId
            setFormData(formData)
        }
    }, [])
    return (
         <>
            {loaded ?
        <div>
            <h1>Registrant Field to Guest Field Mapping</h1>
            <h2>This will pair the registrant to the guest.
            </h2>

            <div
                autoComplete="off"
                className={styles.container}
                    >
                <div className={styles.guestSetupForm}>
                    <h3>Examples of simple assignment-
                        <div>'LocalRegistrationId' from registrant matches 'GuestOfRecordNumber' of guest registrant.
                        </div><br />
                        <div><u>Main View Field:</u> LocalRegistrationId<br /><u>Guest View Field:</u> GuestOfRecordNumber</div>
                        <br />
                    </h3>
                </div>
                <div className={styles.guestSetupForm}>
                    <label htmlFor="mainViewField" className={styles.label}>Main View Field: </label>
                    <select
                        name="mainViewField"
                                styles={styles.ThirdPartyListDropdown}
                        value={formData.mainViewField}
                        onChange={handleChange}
                    >
                        <option disabled={true} value="" selected="selected">
                            -- Select an option --
                        </option>
                        {
                                    mainViewFields.map((ci, idx) => (
                                <option key={idx}>{ci}</option>
                            ))
                        }
                    </select>
                </div><br />
                <div className={styles.guestSetupForm}>
                    <label htmlFor="guestViewField" className={styles.label}>Guest View Field: </label>
                    <select
                        name="guestViewField"
                        styles={styles.ThirdPartyListDropdown}
                        value={formData.guestViewField}
                        onChange={handleChange}
                    >
                        <option disabled={true} value="" selected="selected">
                            -- Select an option --
                        </option>
                        {
                            guestViewFields.map((ci, idx) => (
                                <option key={idx}>{ci}</option>
                            ))
                        }
                    </select>
                </div>
                <br /> <br />
                <BackSaveContinueButton
                    continueButtonVisibility={continueButtonVisibility}
                    handleSaveAndNavigate={handleSaveAndNavigate}
                    handleSave={handleSave}
                    styles={styles}
                    navigate={navigate}
                />
                
                
            </div>
        </div>
                :
                <LoadingSpinner />
            }
        </>
    );
}

export default RegistrantToGuestMapping;